<template>
    <div id="pleating-list-details-page">
        <pre
            class="debug"
            v-if="isDebug"
            >{{ recordDict }}</pre
        >
        <actions-menu>
            <actions-menu-item
                :v4="true"
                id="pleatinglistdetails-backToFormFromPaintlistview"
                :action="() => $router.push('/pleatinglistoverview')"
                icon="arrow-left"
                :label="trans('pages.pleating_list_details.back_to_overview')"
            />
            <actions-menu-item
                :v4="true"
                :action="markListSawn"
                icon="check"
                :label="trans('pages.pleating_list_details.pleated')"
            />
            <actions-menu-item
                :v4="true"
                v-if="false"
                id="pleatinglistdetails-editPaintlist"
                :action="
                    () =>
                        $router.push(
                            '/pleatinglistedit/' + idParam + '?productId=-1'
                        )
                "
                icon="pencil"
                :label="trans('pages.pleating_list_details.edit')"
            />
            <actions-menu-item
                :v4="true"
                :action="removeList"
                class="alert"
                icon="exclamation-circle"
                :label="trans('pages.pleating_list_details.delete')"
            />
            <actions-menu-item
                :v4="true"
                :action="exportPleatingList"
                icon="floppy-o"
                :label="trans('pages.pleating_list_details.export')"
            />
        </actions-menu>
        <loader v-if="loading" />
        <template v-else>
            <div class="top-buttons">
                <ui5-button @click="previousPleatingList">
                    {{ trans('pages.pleating_list_details.previous') }}
                </ui5-button>
                <ui5-button @click="nextPleatingList">
                    {{ trans('pages.pleating_list_details.next') }}
                </ui5-button>
            </div>
            <div class="container row">
                <div class="col-67">
                    <div class="paintlist-title">
                        <div v-if="allComplete">
                            <h2>
                                {{
                                    trans(
                                        'pages.pleating_list_details.pleating_order_completed'
                                    )
                                }}
                            </h2>
                        </div>
                    </div>
                </div>

                <div class="clearer" />

                <div class="box">
                    <div class="box-title">
                        {{ trans('pages.pleating_list_details.info') }}
                    </div>

                    <div class="box-row">
                        <div class="box-25">
                            {{
                                trans(
                                    'pages.pleating_list_details.creation_date'
                                )
                            }}
                        </div>
                        <div class="box-25">
                            <span v-if="pleatingList">
                                {{ pleatingList.creationDate }}
                            </span>
                        </div>

                        <div class="box-25">
                            {{ trans('pages.pleating_list_details.deadline') }}
                        </div>
                        <div class="box-25">
                            <span v-if="pleatingList && pleatingList.deadline">
                                {{ pleatingList.deadline }}
                            </span>
                        </div>
                        <template
                            v-if="pleatingList"
                            v-for="creationFilter in creationFilters"
                        >
                            <template
                                v-if="isDebug || !creationFilter.debugOnly"
                            >
                                <div class="box-25">
                                    {{ creationFilter.label }}
                                </div>
                                <div class="box-25">
                                    {{ creationFilter.value }}
                                </div>
                            </template>
                        </template>
                    </div>
                </div>

                <br />
                <br />

                <div class="clearer" />

                <div class="container row">
                    <div class="col-90">
                        <div class="paintlist-field">
                            <label for="description">
                                {{
                                    trans(
                                        'pages.pleating_list_details.description'
                                    )
                                }}
                            </label>
                            <textarea
                                v-if="pleatingList"
                                id="description"
                                @blur="onDescriptionBlur"
                                v-model="pleatingList.description"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <h4>
                {{ trans('pages.pleating_list_details.products_in_package') }}
            </h4>
            <div v-if="pleatingList && pleatingList.products">
                <div
                    class="productiditem link"
                    v-for="product in pleatingList.products"
                    :key="'product.' + product.productNr"
                    @click="goToProductPage(product.productId)"
                >
                    {{ product.productNr }}
                </div>
            </div>

            <div class="clearer" />

            <br />
            <div
                class="product-table"
                v-if="
                    pleatingList &&
                    (!pleatingList.products ||
                        pleatingList.products.length == 0)
                "
            >
                <li>{{ trans('pages.pleating_list_details.no_products') }}</li>
            </div>
            <table
                cellspacing="0"
                cellpadding="0"
                id="pleatinglistdetails-profile-overview"
                class="product-table"
            >
                <thead>
                    <tr class="product-table-header-tr">
                        <th class="product-table-header-td" />
                        <th class="product-table-header-td image-column">
                            {{ trans('pages.pleating_list_details.image') }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="left"
                        >
                            {{
                                trans('pages.pleating_list_details.description')
                            }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="center"
                        >
                            {{ trans('pages.pleating_list_details.finished') }}
                        </th>
                    </tr>
                </thead>
                <tbody v-if="pleatingList && pleatingList.products">
                    <template
                        v-for="[product, records] in pleatingList.products.map(
                            (x) => [x, recordDict[x.productId]]
                        )"
                    >
                        <tr
                            :key="'listProduct.' + product.productNr"
                            class="product-table-item-tr"
                        >
                            <td class="ball-column">
                                <div
                                    class="bol"
                                    :style="{
                                        backgroundColor: records.every(
                                            (record) => record.sawn == 1
                                        )
                                            ? 'green'
                                            : 'red',
                                    }"
                                />
                            </td>
                            <td
                                align="center"
                                class="image-column"
                                valign="center"
                            >
                                <img
                                    class="pleatinglistProductImage"
                                    @click="selectedImageProduct = product"
                                    :src="product.imageSrc"
                                    :alt="product.productNr"
                                />
                            </td>
                            <td align="left">
                                <div class="paintlistbold">
                                    {{ product.productNr }} -
                                    {{ product.productType.label }} ({{
                                        trans('products.count_colon_value', {
                                            count: product.count,
                                        })
                                    }})
                                </div>
                                <div class="paintlistitalic">
                                    {{ product.customerName }}
                                </div>
                                <div class="paintlistitalic">
                                    {{ product.reference }}
                                </div>
                                <div class="paintlistitalic">
                                    {{ product.color.ralnr
                                    }}{{ product.color.raltype }}
                                </div>
                                <br />
                                <div
                                    class="paintlistdefault"
                                    v-if="getCreationFilter(product)"
                                >
                                    {{ getCreationFilter(product).label }}:
                                    {{
                                        Math.round(
                                            getCreationFilter(product)
                                                .fieldvalue * 100
                                        ) / 100
                                    }}
                                    mm
                                </div>
                                <div
                                    class="paintlistdefault"
                                    v-if="getDataFieldLength(product)"
                                >
                                    {{ getDataFieldLength(product).label }}:
                                    {{
                                        Math.round(
                                            getDataFieldLength(product)
                                                .fieldvalue * 100
                                        ) / 100
                                    }}
                                    mm
                                </div>
                                <div
                                    class="paintlistdefault"
                                    v-if="getDataFieldUnfoldment(product)"
                                >
                                    {{ getDataFieldUnfoldment(product).label }}:
                                    {{
                                        Math.round(
                                            getDataFieldUnfoldment(product)
                                                .fieldvalue * 100
                                        ) / 100
                                    }}
                                    mm
                                </div>
                            </td>
                            <td align="center">
                                <input
                                    type="checkbox"
                                    :checked="
                                        records.every(
                                            (record) => record.sawn == 1
                                        )
                                    "
                                    @change="onFinishToggle($event, records)"
                                />
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </template>
        <image-modal
            v-if="selectedImageProduct"
            :source="selectedImageProduct.imageSrc"
            @modal-click="selectedImageProduct = null"
            :title="selectedImageProduct.productNr"
        />
    </div>
</template>

<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import pleatingListApi from '../api/pleatingList';
import Loader from '../components/loader/Loader';
import IsDebugMixin from '../mixins/is-debug';
import IdParamMixin from '../mixins/id-param';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import localization from '../mixins/localization';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../dialogs';
import ImageModal from '../components/modals/ImageModal';

export default {
    components: {
        ImageModal,
        Loader,
        ActionsMenu,
        ActionsMenuItem,
    },
    mixins: [
        IsDebugMixin,
        IdParamMixin(),
        NavigationFunctionsMixin,
        localization,
    ],
    computed: {
        creationFilters() {
            if (!this.pleatingList || !this.pleatingList.creationInfo) {
                return null;
            }

            return this.pleatingList.creationInfo.map((x) => {
                return {
                    label: x.datafieldName,
                    value: x.value ?? '?',
                    debugOnly: !['materialtype', 'thickness'].includes(
                        x.datafieldKey
                    ),
                };
            });
        },
        allComplete() {
            if (!this.pleatingList) {
                return false;
            }

            const allComplete = (this.pleatingList.products || []).every(
                (product) => {
                    const records = this.recordDict[product.productId];
                    return records.every((record) => record.sawn == 1);
                }
            );

            if (allComplete) {
                window.scrollTo(0, 0);
            }

            return allComplete;
        },
    },
    data() {
        return {
            loading: false,
            pleatingList: null,
            recordDict: null,
            selectedImageProduct: null,
        };
    },
    methods: {
        previousPleatingList() {
            pleatingListApi
                .previous(this.idParam)
                .then((response) => {
                    this.$router.push(
                        '/pleatinglistdetails/' + response.data.data
                    );
                })
                .catch((error) => {
                    if (error.response && error.response.status === 404) {
                        showInfoMessage(
                            this.trans(
                                'pages.pleating_list_details.no_previous_pleating_order'
                            )
                        );
                    } else {
                        showErrorMessage(
                            this.trans(
                                'pages.pleating_list_details.unknown_error'
                            )
                        );
                    }
                });
        },
        nextPleatingList() {
            pleatingListApi
                .next(this.idParam)
                .then((response) => {
                    this.$router.push(
                        '/pleatinglistdetails/' + response.data.data
                    );
                })
                .catch((error) => {
                    if (error.response && error.response.status === 404) {
                        showInfoMessage(
                            this.trans(
                                'pages.pleating_list_details.no_next_pleating_order'
                            )
                        );
                    } else {
                        showErrorMessage(
                            this.trans(
                                'pages.pleating_list_details.unknown_error'
                            )
                        );
                    }
                });
        },
        onDescriptionBlur() {
            if (this.idParam !== null) {
                pleatingListApi
                    .updateDescription(
                        parseInt(this.idParam),
                        this.pleatingList.description
                    )
                    .catch(() => {
                        showErrorMessage(
                            this.trans(
                                'pages.pleating_list_details.description_save_error'
                            )
                        );
                    });
            }
        },
        exportPleatingList() {
            window.open(
                Config.url +
                    '/export/exportPleatinglist/?pleatingListId=' +
                    this.idParam,
                '_blank'
            );
        },
        markListSawn() {
            showInfoMessage(
                this.trans('pages.pleating_list_details.status_update_message')
            );
            pleatingListApi
                .updateSawn(
                    this.idParam,
                    this.$store.getters['currentUser/getUserId']
                )
                .then(() => {
                    sessionStorage.pleatingListId = this.idParam;
                    this.$router.push('/pleatinglistoverview');
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.pleating_list_details.unknown_error')
                    );
                });
        },
        onFinishToggle(e, records) {
            e.target.disabled = true;
            const sawn = e.target.checked;
            const promises = records.map((record) => {
                return pleatingListApi
                    .updateSawnForRecord(parseInt(record.ID), sawn)
                    .then(() => {
                        record.sawn = sawn ? 1 : 0;
                    });
            });
            Promise.all(promises)
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.pleating_list_details.unknown_error')
                    );
                })
                .finally(() => {
                    e.target.disabled = false;
                });
        },
        createRecordDict() {
            const recordDict = {};
            this.pleatingList.profiles.forEach((record) => {
                record.products.forEach((productNr) => {
                    if (!recordDict[productNr]) {
                        recordDict[productNr] = [];
                    }
                    recordDict[productNr].push(record);
                });
            });
            return recordDict;
        },
        getCreationFilter(product) {
            return product.datafields.find((x) => {
                return (
                    x.datafieldId == product.productType.pleatingCreationFilter
                );
            });
        },
        getDataFieldLength(product) {
            return product.datafields.find((x) => {
                return x.name == 'length';
            });
        },
        getDataFieldUnfoldment(product) {
            return product.datafields.find((x) => {
                return x.name == 'unfoldment';
            });
        },
        load() {
            this.loading = true;
            pleatingListApi
                .fetchDetails(this.idParam, true)
                .then((response) => {
                    const pleatingList = response.data.data;
                    this.$store.commit(
                        'general/setPageTitle',
                        this.trans('pages.pleating_list_details.page_title', {
                            nr: pleatingList.nr,
                        }),
                        { root: true }
                    );
                    pleatingList.products.forEach((product) => {
                        product.imageSrc =
                            Config.url +
                            '/product/customImage/?productId=' +
                            product.productNr +
                            '&random=' +
                            Math.random();
                    });
                    this.pleatingList = pleatingList;
                    this.recordDict = this.createRecordDict();
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.pleating_list_details.fetch_error')
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        removeList() {
            showConfirmDialog({
                title: this.trans(
                    'pages.pleating_list_details.delete_confirm_title'
                ),
                content: this.trans(
                    'pages.pleating_list_details.delete_confirm_content'
                ),
                confirm: () => {
                    pleatingListApi
                        .remove(this.idParam)
                        .then(() => {
                            this.$router.push('/pleatinglistoverview');
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans(
                                    'pages.pleating_list_details.delete_error'
                                )
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.pleating_list_details.yes'),
                cancelButton: this.trans('pages.pleating_list_details.no'),
            });
        },
    },
};
</script>
